import React, { useEffect, useContext, useState } from 'react';
import './application-submitted.scss';
import { VodalendPersonalLogo, OmfLogo, TickOutline, VodaLendLogoRed } from 'assets';
import { LendingContext } from 'context';
import { TealiumService, getBannerUrl } from 'services';
import { applicationDefaults } from 'utils';

const DEEPLINK = 'DEEPLINK';

export const ApplicationSubmitted = () => {
  const { application } = useContext(LendingContext);
  const [crossSellBanner, setCrossSellBanner] = useState(null);

  useEffect(() => {
    const omfOffer = JSON.parse(sessionStorage.getItem('omfOffer') || 'null');
    TealiumService.onApplicationSubmittedStart(omfOffer, application?.offers?.hashId);

    const applyBanner = (banner) => {
      if (banner) {
        setCrossSellBanner({
          imageUrl: banner.imageUrl,
          deepLink: banner.deepLink,
          analyticsTag: banner.analyticsTag,
          buttonText: banner.buttonText,
        });
      }
    };

    const stored = JSON.parse(sessionStorage.getItem('crossSellBanner') || 'null');
    if (stored) {
      applyBanner(stored);
    } else {
      getBannerUrl().then((data) => {
        if (data) {
          sessionStorage.setItem('crossSellBanner', JSON.stringify(data.banner));
          applyBanner(data.banner);
        }
      });
    }
  }, []);

  return (
    <section className='app-submitted'>
      <header className='app-submitted__mobile-header is-hidden-tablet'>
        <h1 className='app-submitted__mobile-header-title'>Confirmation</h1>
      </header>

      <header className='app-submitted__desktop-header is-hidden-mobile'>
        <img src={VodaLendLogoRed} alt='VodaLend' className='app-submitted__desktop-header-logo' />
      </header>

      <main className='app-submitted__content'>
        <div className='app-submitted__card'>
          <div className='app-submitted__body'>
            <div className='app-submitted__check-wrap' aria-hidden='true'>
              <img className='app-submitted__checkmark' src={TickOutline} alt='' />
            </div>

            <h2 className='app-submitted__heading'>Application submitted successfully</h2>

            <p className='app-submitted__description'>
              Please expect a call from our trusted partner, Old Mutual Finance. They will contact you
              shortly from 021 980 0655.
            </p>

            { crossSellBanner ? (
              <figure
                className='cross-sell-banner v-container'
                style={{ backgroundImage: `url(${crossSellBanner.imageUrl})` }}
                onClick={() => {
                  window.utag?.link({ link_id: crossSellBanner.analyticsTag });
                  window.my?.postMessage({ messageType: DEEPLINK, breakoutUrl: crossSellBanner.deepLink }, '*');
                }}
              >
                {crossSellBanner.buttonText && <button className='cross-sell-banner-button'>{crossSellBanner.buttonText}</button>}
              </figure>
            ) : null}
          </div>

          <footer className='app-submitted__footer'>
            <img
              className='app-submitted__vodalend-logo'
              src={VodalendPersonalLogo}
              alt='VodaLend personal loans'
            />

            <div className='app-submitted__branding'>
              <img
                className='app-submitted__omf-logo'
                src={OmfLogo}
                alt='Old Mutual Finance'
              />
            </div>

            <button
              className='app-submitted__finish is-hidden-tablet'
              onClick={() => (window.location.href = applicationDefaults.staticHomeUrl)}
            >
              Finish
            </button>
          </footer>
        </div>
      </main>

      <footer className='app-submitted__desktop-footer is-hidden-mobile'>
        <div className='btn-placeholder' />
        <div className='btn-placeholder'>
          <button
            className='app-submitted__desktop-finish'
            onClick={() => (window.location.href = applicationDefaults.staticHomeUrl)}
          >
            Finish
          </button>
        </div>
      </footer>
    </section>
  );
};
